import React, { FC, useEffect } from 'react'
import { ApolloProvider, ApolloClient, HttpLink, concat, split, ApolloLink } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { getMainDefinition } from '@apollo/client/utilities'
import { useOktaAuth } from '@okta/okta-react'

import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link'
import { subsAWSConfig } from '../shared/config'

import { cache } from './cache'

import { tokenVar } from 'modulesCommon/store'

export const AuthApolloProvider: FC = ({ children }) => {
  const { authState } = useOktaAuth()

  const token = authState?.idToken?.idToken || ''
  const authMiddleware = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      authorization: token
    }
  }))

  const httpLink = new HttpLink({ uri: process.env.REACT_APP_API_URL })
  const namedLink = new ApolloLink((operation, forward) => {
    operation.setContext(() => ({
      uri: `${process.env.REACT_APP_API_URL}?${operation.operationName}`
    }))
    return forward ? forward(operation) : null
  })
  const subsAWSLink = createSubscriptionHandshakeLink(subsAWSConfig(authState?.idToken?.idToken || ''), httpLink)

  const splitLink = split(
    ({ query }) => {
      const definition = getMainDefinition(query)

      return definition.kind === 'OperationDefinition' && definition.operation === 'subscription'
    },
    subsAWSLink,
    concat(authMiddleware, httpLink)
  )

  const client = new ApolloClient({
    cache,
    link: ApolloLink.from([namedLink, splitLink]),
    connectToDevTools: true // TODO: show only on local/dev envs?
  })

  useEffect(() => tokenVar(authState?.idToken?.idToken), [authState?.idToken])

  return <ApolloProvider client={client}>{children}</ApolloProvider>
}
